module.exports = __webpack_public_path__ + "img/23.00141376.jpg";